import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortDescription'
})
export class shortDescriptionPipe implements PipeTransform {

  transform(value: string): any {
  
    if (value == null || value == undefined || value.length <= 0 ) {
      return value;
    }
    if(value.length <= 40 ) {
      return value;
    }
    if (value.length > 40 ){
      return value.substring(0,40) + '...';
    }
    return value;
  }

}
